import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    feature: String,
    tier: String,
    title: String,
    description: String,
    tierLabel: String,
    tierColor: String,
    tierBg: String,
    upgradeUrl: String,
    locked: { type: Boolean, default: true }
  }

  static targets = ["wrapper"]

  connect() {
    if (!this.lockedValue) return

    this._injectLockIcon()
    this._addTooltip()
  }

  openModal(event) {
    event.preventDefault()
    event.stopPropagation()

    const modal = document.getElementById("featureGateModal")
    if (!modal) return

    this._populateModal(modal)

    const bsModal = bootstrap.Modal.getOrCreateInstance(modal)
    bsModal.show()
  }

  // -- Private-ish helpers --------------------------------------------------

  _injectLockIcon() {
    const target = this.element.querySelector("button, a, .btn")
    if (!target) return
    if (target.querySelector(".feature-gate-lock-icon")) return

    const icon = document.createElement("i")
    icon.className = "fas fa-lock feature-gate-lock-icon"
    target.prepend(icon)
  }

  _addTooltip() {
    this.element.setAttribute("title", `Requires ${this.tierLabelValue} plan`)

    if (typeof bootstrap !== "undefined" && bootstrap.Tooltip) {
      new bootstrap.Tooltip(this.element, { trigger: "hover" })
    }
  }

  _populateModal(modal) {
    // Tier badge
    const badge = modal.querySelector("[data-fg-tier-badge]")
    if (badge) {
      badge.textContent = `${this.tierLabelValue} feature`
      badge.style.color = this.tierColorValue
      badge.style.background = this.tierBgValue
    }

    // Title and description
    const titleEl = modal.querySelector("[data-fg-title]")
    if (titleEl) titleEl.textContent = this.titleValue

    const descEl = modal.querySelector("[data-fg-description]")
    if (descEl) descEl.textContent = this.descriptionValue

    // Highlight the correct tier chip
    const chips = modal.querySelectorAll("[data-fg-tier-chip]")
    chips.forEach((chip) => {
      const chipTier = chip.getAttribute("data-fg-tier-chip")
      if (chipTier === this.tierValue) {
        chip.classList.add("feature-gate-modal__chip--active")
        chip.style.borderColor = this.tierColorValue
        chip.style.color = this.tierColorValue
        chip.style.background = this.tierBgValue
      } else {
        chip.classList.remove("feature-gate-modal__chip--active")
        chip.style.borderColor = "#e5e7eb"
        chip.style.color = "#6b7280"
        chip.style.background = "transparent"
      }
    })

    // CTA link
    const cta = modal.querySelector("[data-fg-cta]")
    if (cta) cta.href = this.upgradeUrlValue
  }
}
